import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/sendBox/SendBox.module_built.css";
const classes = {"sendbox__sendbox-controls--in-grid":"wHTirJa_sendbox__sendbox-controls--in-grid","sendbox__attachment-bar":"wHTirJa_sendbox__attachment-bar","sendbox__attachment-bar--in-grid":"wHTirJa_sendbox__attachment-bar--in-grid","sendbox__sendbox-text-area":"wHTirJa_sendbox__sendbox-text-area","sendbox__telephone-keypad--in-grid":"wHTirJa_sendbox__telephone-keypad--in-grid","sendbox__text-counter":"wHTirJa_sendbox__text-counter","sendbox":"wHTirJa_sendbox","sendbox__sendbox-controls":"wHTirJa_sendbox__sendbox-controls","sendbox__text-counter--error":"wHTirJa_sendbox__text-counter--error","sendbox__sendbox":"wHTirJa_sendbox__sendbox","sendbox__text-area--in-grid":"wHTirJa_sendbox__text-area--in-grid","variant-copilot":"wHTirJa_variant-copilot"}
export default classes

const _sendbox__sendbox_controls__in_grid0 = classes["sendbox__sendbox-controls--in-grid"]
export { _sendbox__sendbox_controls__in_grid0 as "sendbox__sendbox-controls--in-grid" }

const _sendbox__attachment_bar0 = classes["sendbox__attachment-bar"]
export { _sendbox__attachment_bar0 as "sendbox__attachment-bar" }

const _sendbox__attachment_bar__in_grid0 = classes["sendbox__attachment-bar--in-grid"]
export { _sendbox__attachment_bar__in_grid0 as "sendbox__attachment-bar--in-grid" }

const _sendbox__sendbox_text_area0 = classes["sendbox__sendbox-text-area"]
export { _sendbox__sendbox_text_area0 as "sendbox__sendbox-text-area" }

const _sendbox__telephone_keypad__in_grid0 = classes["sendbox__telephone-keypad--in-grid"]
export { _sendbox__telephone_keypad__in_grid0 as "sendbox__telephone-keypad--in-grid" }

const _sendbox__text_counter0 = classes["sendbox__text-counter"]
export { _sendbox__text_counter0 as "sendbox__text-counter" }

const _sendbox0 = classes["sendbox"]
export { _sendbox0 as "sendbox" }

const _sendbox__sendbox_controls0 = classes["sendbox__sendbox-controls"]
export { _sendbox__sendbox_controls0 as "sendbox__sendbox-controls" }

const _sendbox__text_counter__error0 = classes["sendbox__text-counter--error"]
export { _sendbox__text_counter__error0 as "sendbox__text-counter--error" }

const _sendbox__sendbox0 = classes["sendbox__sendbox"]
export { _sendbox__sendbox0 as "sendbox__sendbox" }

const _sendbox__text_area__in_grid0 = classes["sendbox__text-area--in-grid"]
export { _sendbox__text_area__in_grid0 as "sendbox__text-area--in-grid" }

const _variant_copilot0 = classes["variant-copilot"]
export { _variant_copilot0 as "variant-copilot" }
